import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSort = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgSort" data-sentry-source-file="sort.tsx">
    <path fill="#263E6A" d="M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z" data-sentry-element="path" data-sentry-source-file="sort.tsx" />
  </svg>;
export default SvgSort;